import {
  BlogThemesWithPostsQueryDocument,
} from '@medprev-web-app/api-graphql-client';

import { ApolloClient } from '@/graphql/apollo-client';
import { BlogThemesResponse } from '@/types/blog.type';

export async function getBlogThemesWithPost(): Promise<BlogThemesResponse | null> {
  const { data } = await ApolloClient.query({
    query: BlogThemesWithPostsQueryDocument,
    errorPolicy: 'all',
  });

  const themes = (data?.blogThemesWithPosts ?? [])
    .filter((theme): theme is NonNullable<typeof theme> => Boolean(theme && theme.slug));

  if (!themes.length) {
    return null;
  }

  return {
    data: themes.map((theme, index) => ({
      id: Number(theme.id ?? index),
      name: theme.name || 'Sem tema',
      slug: theme.slug || '',
      posts: {
        data:
            theme.posts?.data?.filter((post): post is NonNullable<typeof post> => Boolean(post?.slug)) ?? [],
      },
    })),
  };
}
